import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Section } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Icon } from './ui/Icon';

const INDUSTRY_ICONS = ['factory', 'heart', 'truck', 'briefcase', 'store', 'landmark'];

export const Industries = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <Section
      id="work"
      eyebrow={t.work.eyebrow}
      title={t.work.title}
      subtitle={t.work.subtitle}
      align="center"
      className="bg-elev"
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {t.work.industries.map((ind, i) => (
          <Reveal key={ind.name} delay={70 * i}>
            <article
              className="group relative rounded-3xl border bg-surface p-6 h-full overflow-hidden lift"
              style={{ borderColor: 'var(--border)' }}
            >
              <div
                className="absolute top-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity"
                style={{
                  background: 'linear-gradient(90deg, var(--brand), var(--accent))',
                }}
              />
              <div className="flex items-center gap-3">
                <span
                  className="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-elev text-app"
                  style={{ border: '1px solid var(--border)' }}
                >
                  <Icon name={INDUSTRY_ICONS[i]} size={18} />
                </span>
                <h3 className="text-lg font-semibold text-app">{ind.name}</h3>
              </div>
              <p className="mt-4 text-sm text-muted leading-relaxed">{ind.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};

export default Industries;
